"use client";
import Select, { SingleValue, MultiValue, PropsValue } from "react-select";
import { Controller, Control } from "react-hook-form";
import React from "react";
import ErrorMessage from "@/components/shared/Form/ErrorMessage";

interface OptionType {
  value: string | number;
  label: string;
}

interface CustomSelectProps {
  options: OptionType[];
  name: string;
  control: Control<any>;
  errors: any;
  isMulti?: boolean;
  optionsComponent?: any;
}

const CustomSelect: React.FC<CustomSelectProps> = ({
  options,
  name,
  control,
  errors,
  optionsComponent,
  isMulti = false,
}) => (
  <div className="w-full">
    <Controller
      name={name}
      control={control}
      render={({ field }) => {
        // Ensure field.value is properly typed and initialized
        const value = isMulti
          ? (field?.value as string[] | undefined)
              ?.map((val) => options?.find((option) => option?.value === val))
              ?.filter((option): option is OptionType => option !== undefined)
          : options?.find((option) => option?.value === field?.value) || null;

        return (
          <div>
            <Select<OptionType, boolean>
              {...field}
              options={options}
              components={optionsComponent ? { Option: optionsComponent } : {}}
              onChange={(
                selectedOption: SingleValue<OptionType> | MultiValue<OptionType>
              ) => {
                if (isMulti) {
                  // Handle multi-select
                  field.onChange(
                    (selectedOption as MultiValue<OptionType>).map(
                      (option) => option.value
                    )
                  );
                } else {
                  // Handle single-select
                  field.onChange(
                    (selectedOption as SingleValue<OptionType>)?.value || ""
                  );
                }
              }}
              value={value as PropsValue<OptionType>}
              isMulti={isMulti}
              placeholder="اختر"
              className="w-full text-right"
            />
            <ErrorMessage errors={errors} name={name} />
          </div>
        );
      }}
    />
  </div>
);

export default CustomSelect;
